"use client";

import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import Link from "next/link";
import { useRouter } from "next/navigation";

type NavItem = {
  href: string;
  label: string;
  external?: boolean;
};

const NAV_ITEMS: NavItem[] = [
  { href: "#about-us", label: "私たちについて" },
  { href: "#success-stories", label: "転職成功事例" },
  { href: "#fee-structure", label: "サポート内容" },
  { href: "#service-flow", label: "ご利用の流れ" },
  { href: "/faq", label: "FAQ" },
];

const ACTION_ITEMS: NavItem[] = [
  { href: "/career", label: "職務経歴書の添削" },
  { href: "/interview-advice/prepare-interview", label: "面接対策" },
  { href: "/scouts", label: "スカウトを見る" },
];

export default function DashboardMobileMenu() {
  const [open, setOpen] = useState(false);
  const router = useRouter();

  // 外部トリガーから開閉できるようにする
  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("open-dashboard-menu", handler as EventListener);
    return () => window.removeEventListener("open-dashboard-menu", handler as EventListener);
  }, []);

  const handleNavigate = (item: NavItem) => {
    const { href } = item;

    if (href.startsWith("#")) {
      // ページ内リンクはスムーズスクロール
      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      setOpen(false);
      return;
    }

    if (href.startsWith("http")) {
      window.open(href, item.external ? "_blank" : "_self");
      setOpen(false);
      return;
    }

    router.push(href);
    setOpen(false);
  };

  return (
    <>
      {/* スライドメニュー */}
      <div
        className={`fixed top-0 right-0 h-full w-72 bg-white shadow-xl transform transition-transform duration-300 ease-in-out z-[65] md:hidden ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
          <span className="text-sm font-semibold text-gray-700">
            メニュー
          </span>
          <button
            aria-label="メニューを閉じる"
            onClick={() => setOpen(false)}
            className="p-2 rounded-full hover:bg-gray-100"
          >
            <X size={22} />
          </button>
        </div>

        <nav className="flex flex-col gap-3 px-6 py-4 text-gray-800">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.href}
              onClick={() => handleNavigate(item)}
              className="text-left py-2 text-base hover:text-primary-600"
            >
              {item.label}
            </button>
          ))}

          <div className="h-px bg-gray-200 my-2" />

          {ACTION_ITEMS.map((item) => (
            <button
              key={item.href}
              onClick={() => handleNavigate(item)}
              className="text-left py-2 text-base hover:text-primary-600"
            >
              {item.label}
            </button>
          ))}

          <div className="mt-4 space-y-2">
            <Link
              href="/auth/register"
              onClick={() => setOpen(false)}
              className="block w-full text-center bg-primary-600 hover:bg-primary-700 text-white py-3 rounded-full text-sm font-semibold"
            >
              添削サービスに申し込む
            </Link>
            <Link
              href="/auth/login"
              onClick={() => setOpen(false)}
              className="block w-full text-center bg-secondary-900 hover:bg-secondary-800 text-white py-3 rounded-full text-sm font-semibold"
            >
              ログイン
            </Link>
          </div>
        </nav>
      </div>

      {/* オーバーレイ */}
      {open && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-[60] md:hidden"
          onClick={() => setOpen(false)}
          aria-hidden
        />
      )}
    </>
  );
}

